// External script provided by a third party
// import initLTL from './LTLChatScript';
import initLTLEmbeddedMessaging from './LTLEnhancedChatScript';

const freightSalesForceChat = () => ({
  showChatWindow() {
    window?.embeddedservice_bootstrap?.utilAPI?.removeAllComponents();
    // eslint-disable-next-line no-undef
    const { REACT_APP_LTL_SALESFORCE_EMBEDDED_ID, REACT_APP_LTL_SALESFORCE_EMBEDDED_SERVICE } = process.env;
    if (!Array.from(document.scripts).some((s) => s.src && s.src.includes(REACT_APP_LTL_SALESFORCE_EMBEDDED_ID))) {
      const s = document.createElement('script');
      s.setAttribute('src', REACT_APP_LTL_SALESFORCE_EMBEDDED_SERVICE);
      s.onload = () => {
        initLTLEmbeddedMessaging();
        setTimeout(() => {
          window.embeddedservice_bootstrap.bootstrapEmbeddedMessaging();
        }, 2000);
      };

      document.body.appendChild(s);
    } else {
      initLTLEmbeddedMessaging();
      setTimeout(() => {
        window.embeddedservice_bootstrap.bootstrapEmbeddedMessaging();
      }, 2000);
    }
  },
});

export default freightSalesForceChat;
